    import React, {useEffect, useState} from "react";
    import {Dropdown, Input, Spin} from "antd";
    import {DropDownCheck, SearchIcon, SFilterIcon} from "../../../../assets/icons/defaultIcons";
    import {Controller, useForm} from "react-hook-form";
    import {maxLength} from "../../../utils/patterns";
    import JournalCard from "../../../components/dashboard/cards/journal-card/JournalCard";
    import dayjs from "dayjs";
    import {JournalService} from "../../../services/journals-api.service";
    import {useDebounce} from "../../../hooks/useDebounce";
    import {LoadingOutlined} from '@ant-design/icons';
    import NoRecord from "../../../components/dashboard/no-record/NoRecord";

    export default function AllJournals() {
        const [allJournals, setAllJournals] = useState(null);
        const [selectedItem, setSelectedItem] = useState("All");
        const [listing, setListing] = useState(false);
        const [loader, setLoader] = useState(true);
        const [search, setSearch] = useState("");

        const debouncedSearch = useDebounce(search, 500); // Debounce with 500ms delay
        console.log(debouncedSearch,'search')

        const {
            control,
        } = useForm({
            mode: "onChange",
        });

        async function GetJournals(type, searchQuery) {
            setLoader(true);
            const response = await JournalService.getJournal(
                type || "", // Ensure type is correctly passed
                "",
                false,
                false,
                false,
                true,
                "createdAt",
                "desc",
                searchQuery || "" // Ensure searchQuery is passed correctly
            );

            if (response?.data?.data?.status) {
                setAllJournals(response?.data?.data?.data?.result);
            }
            setLoader(false);
        }

        useEffect(() => {
            console.log("Fetching Journals with:", selectedItem, debouncedSearch);
            GetJournals(selectedItem !== "All" ? selectedItem : "", debouncedSearch);
        }, [selectedItem, listing, debouncedSearch]);

        useEffect(() => {
            console.log("Debounced Search:", debouncedSearch);
        }, [debouncedSearch]);

        const items = [
            { key: "1", label: (<a onClick={() => setSelectedItem("All")} className="d-flex justify-content-between w-100">All {selectedItem === "All" && <DropDownCheck />}</a>) },
            { key: "2", label: (<a onClick={() => setSelectedItem("free-flow")} className="d-flex justify-content-between w-100">Free Flow {selectedItem === "free-flow" && <DropDownCheck />}</a>) },
            { key: "3", label: (<a onClick={() => setSelectedItem("re-frame")} className="d-flex justify-content-between w-100">Re Frame {selectedItem === "re-frame" && <DropDownCheck />}</a>) },
            { key: "4", label: (<a onClick={() => setSelectedItem("devotional")} className="d-flex justify-content-between w-100">Devotional {selectedItem === "devotional" && <DropDownCheck />}</a>) },
        ];

        return (
            <div className="journal-section">
                <h4>
                    {allJournals?.length} Journals
                    <span>
                        <Dropdown menu={{ items }} placement="bottomLeft" trigger={"click"}>
                            <span className="journal-dropdown"><SFilterIcon /> {selectedItem}</span>
                        </Dropdown>
                    </span>
                </h4>
                <div className="dfields">
                    <Controller
                        name="search"
                        defaultValue=""
                        control={control}
                        rules={{ maxLength: maxLength(500) }}
                        render={({ field }) => (
                            <div className="text-field">
                                <Input
                                    {...field}
                                    placeholder="Search"
                                    prefix={loader ?  <Spin indicator={<LoadingOutlined style={{ fontSize: 22 }} spin />} /> :<SearchIcon />}
                                    onChange={(e) => setSearch(e.target.value)}
                                    value={search}
                                />
                            </div>
                        )}
                    />
                </div>
                <div>
                    {allJournals?.length > 0 ? (
                        allJournals.map((item, index) => (
                            <JournalCard
                                listing={listing}
                                setListing={setListing}
                                key={index}
                                id={item._id}
                                answer={item.content[0].text}
                                type={item.type}
                                date={dayjs(item.createdAt).format("DD-MM-YYYY")}
                            />
                        ))
                    ) : (
                        <NoRecord />
                    )}
                </div>
            </div>
        );
    }
